export default "__VITE_ASSET__C7prQR7U__"